import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import ClearIcon from "@mui/icons-material/Clear";
import { IconButton, TextField } from "@mui/material";
import axios from "config/axios";
import { toast } from "react-toastify";
import { handleAxiosResponseError } from "utils/handleResponseError";

const style = {
  event: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: 800,
    height: "auto",
    maxHeight: 660,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    pt: 2,
  },
};

export default function SendGmailMessageModal({ open, setOpen, googleToken }) {
  const handleClose = () => setOpen(false);
  const [emailInfo, setEmailInfo] = useState({ to: "", subject: "", body: "" });

  const handleSendEmail = () => {
    if (!emailInfo.to) {
      toast.warning("Please enter recepient email");
      return;
    }
    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/sendmessage`, {
        ...emailInfo,
        token : googleToken,
      })
      .then(({ data }) => {
        toast.success(data.message);
        setEmailInfo({ to: "", subject: "", body: "" });
        handleClose();
      })
      .catch((err) => {
        console.log(handleAxiosResponseError(err));
        toast.error(handleAxiosResponseError(err));
      });
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        id="modal">
        <Box sx={style.event}>
          <div className="d-flex justify-content-end">
            <IconButton className="p-0" size="small" onClick={handleClose}>
              <ClearIcon className="p-0" fontSize="small" />
            </IconButton>
          </div>
          <div className="d-flex flex-column">
            <TextField
              id="outlined-basic"
              label="To"
              variant="outlined"
              size="small"
              onChange={(e) =>
                setEmailInfo((prev) => ({ ...prev, to: e.target.value }))
              }
            />
            <br />
            <TextField
              id="outlined-basic"
              label="Subject"
              variant="outlined"
              size="small"
              onChange={(e) =>
                setEmailInfo((prev) => ({ ...prev, subject: e.target.value }))
              }
            />
            <br />
            <TextField
              size="small"
              id="outlined-multiline-flexible"
              label="Body"
              onChange={(e) =>
                setEmailInfo((prev) => ({ ...prev, body: e.target.value }))
              }
              multiline
            />
          </div>
          <div>
            <button className="show-btns mt-3" onClick={handleSendEmail}>
              Send
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
